document.addEventListener('DOMContentLoaded', () => {
  if (!window.gsap) return

  const { gsap } = window

  const hero = document.querySelector('[data-home-hero-section]')
  const useHeroReveal = hero && !window.theme?.designMode

  document.querySelectorAll('[data-fullscreen-push-section]').forEach((section) => {
    const overlay = section.querySelector('[data-push-overlay]')
    const label = section.querySelector('[data-push-label]')
    const headingLines = section.querySelectorAll('[data-push-line]')
    const cta = section.querySelector('[data-push-cta]')

    if (!overlay && !label && !headingLines.length && !cta) return

    if (overlay) gsap.set(overlay, { opacity: 1 })
    if (label) gsap.set(label, { autoAlpha: 0, transition: 'none' })
    if (headingLines.length) gsap.set(headingLines, { yPercent: 120, opacity: 0 })
    if (cta) gsap.set(cta, { autoAlpha: 0, transition: 'none' })

    const fadeOverlay = () => {
      if (overlay) {
        gsap.to(overlay, { opacity: 0, duration: 1.1, ease: 'power2.out' })
      }
    }

    const revealContent = () => {
      const tl = gsap.timeline()

      if (label) {
        tl.to(label, { autoAlpha: 1, duration: 1.2, ease: 'power2.out' }, 0)
      }

      if (headingLines.length) {
        tl.to(
          headingLines,
          {
            yPercent: 0,
            opacity: 1,
            duration: 0.9,
            ease: 'power3.out',
            stagger: 0.12,
          },
          0,
        )
      }

      if (cta) {
        tl.to(cta, { autoAlpha: 1, duration: 1.2, ease: 'power2.out' }, 0)
      }
    }

    const reveal = () => {
      fadeOverlay()
      revealContent()
    }

    const reset = () => {
      if (overlay) gsap.set(overlay, { opacity: 1 })
      if (label) gsap.set(label, { autoAlpha: 0 })
      if (headingLines.length) gsap.set(headingLines, { yPercent: 120, opacity: 0 })
      if (cta) gsap.set(cta, { autoAlpha: 0 })
    }

    const createScrollTrigger = () => {
      if (!window.ScrollTrigger) return
      window.ScrollTrigger.create({
        trigger: section,
        start: 'top 45%',
        onEnter: fadeOverlay,
      })
      window.ScrollTrigger.create({
        trigger: section,
        start: 'top 45%',
        onEnter: revealContent,
      })
      window.ScrollTrigger.create({
        trigger: section,
        start: 'top bottom',
        onLeaveBack: reset,
      })
    }

    if (useHeroReveal) {
      if (hero.hasAttribute('data-hero-revealed')) {
        createScrollTrigger()
      } else {
        const observer = new MutationObserver(() => {
          if (!hero.hasAttribute('data-hero-revealed')) return
          observer.disconnect()
          createScrollTrigger()
        })
        observer.observe(hero, { attributes: true, attributeFilter: ['data-hero-revealed'] })
      }
    } else if (window.ScrollTrigger) {
      createScrollTrigger()
    } else {
      reveal()
    }
  })
})
